import {Routes} from '@angular/router';
import {EventSearchComponent} from './event-search/event-search.component';
import {CartComponent} from './cart/cart.component';
import {ScrapComponent} from './scrap/scrap.component';
import {TransactionsComponent} from './transactions/transactions.component';
import {RefundComponent} from './refund/refund.component';
import {BookingsListComponent} from './bookings/list/bookings-list.component';
import {BookingsViewComponent} from './bookings/view/bookings-view.component';
import {PrivilegeGuard} from '../../guards/privilege/privilege.guard';
import {PendingChangesGuard} from '../../guards/pendingChanges/pending-changes.guard';
import {TransactionDetailComponent} from './transactions/details/transaction-detail.component';
import {PaymentReversalComponent} from "./payment-reversal/payment-reversal.component";
import {TicketsComponent} from './tickets/tickets.component';
import {TicketComponent} from './tickets/ticket/ticket.component';

export const salesTerminalRoutes: Routes = [
  {
    path: '',
    canActivate: [PrivilegeGuard],
    component: EventSearchComponent,
    data: {
      breadcrumb: 'general.api_menu_search'
    },
    children: [
      {
        path: 'search',
        canActivate: [PrivilegeGuard],
        data: {
          breadcrumb: 'general.api_search_results'
        },
        children: [
          {
            path: 'event/:id',
            canActivate: [PrivilegeGuard],
            data: {
              breadcrumb: 'general.api_sales_buy'
            },
            children: []
          }
        ]
      }
    ]
  },
  {
    path: 'cart',
    canActivate: [PrivilegeGuard],
    component: CartComponent,
    data: {
      breadcrumb: 'general.api_cart'
    },
    children: [
      {
        path: 'create-booking',
        canActivate: [PrivilegeGuard],
        children: []
      }
    ]
  },
  {
    path: 'scrap',
    canActivate: [PrivilegeGuard],
    component: ScrapComponent,
    data: {
      breadcrumb: 'general.api_scrap'
    },
    children: []
  },
  {
    path: 'booking-scrap/:id',
    canActivate: [PrivilegeGuard],
    component: ScrapComponent,
    data: {
      breadcrumb: 'general.api_scrap'
    },
    children: []
  },
  {
    path: 'refund',
    canActivate: [PrivilegeGuard],
    component: RefundComponent,
    data: {
      breadcrumb: 'general.api_menu_refund'
    },
    children: []
  },
  {
    path: 'transactions',
    canActivate: [PrivilegeGuard],
    component: TransactionsComponent,
    data: {
      breadcrumb: 'general.api_menu_transactions'
    },
    children: [
      {
        path: 'legacy',
        children: [
          {
            path: 'view/:id',
            component: TransactionDetailComponent,
            canActivate: [PrivilegeGuard],
            canDeactivate: [PendingChangesGuard],
            data: {
              breadcrumb: 'general.api_menu_transactions_view'
            },
            children: []
          }
        ]
      },
      {
        path: 'view/:id',
        component: TransactionDetailComponent,
        canActivate: [PrivilegeGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
          breadcrumb: 'general.api_menu_transactions_view'
        },
        children: []
      }
    ]
  },
  {
    path: 'tickets',
    canActivate: [PrivilegeGuard],
    component: TicketsComponent,
    data: {
      breadcrumb: 'general.api_menu_tickets'
    },
    children: [
      {
        path: 'view/:id',
        component: TicketComponent,
        canActivate: [PrivilegeGuard],
        data: {
          breadcrumb: 'general.api_menu_tickets_view'
        }
      }
    ]
  },
  {
    path: 'invoices',
    canActivate: [PrivilegeGuard],
    data: {
      breadcrumb: 'general.api_menu_invoices'
    },
    children: [
      {
        path: 'view/:id',
        canActivate: [PrivilegeGuard],
        data: {
          breadcrumb: 'general.api_menu_invoices_view'
        },
        children: []
      }
    ]
  },
  {
    path: 'bookings',
    canActivate: [PrivilegeGuard],
    component: BookingsListComponent,
    data: {
      breadcrumb: 'general.api_menu_reservations'
    },
    children: [
      {
        path: 'create',
        canActivate: [PrivilegeGuard],
        data: {
          breadcrumb: 'general.api_menu_reservation_create'
        },
        children: []
      },
      {
        path: 'view/:id',
        component: BookingsViewComponent,
        canActivate: [PrivilegeGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
          breadcrumb: 'general.api_menu_reservation_view'
        },
        children: [
          {
            path: 'waybill',
            canActivate: [PrivilegeGuard],
            children: []
          }
        ]
      }
    ]
  },
  {
    path: 'payment-reversal',
    canActivate: [PrivilegeGuard],
    component: PaymentReversalComponent,
    data: {
      breadcrumb: 'general.api_menu_payment_reversals'
    },
    children: []
  }
];
